import * as React from 'react';
import ReactQuill, { Quill } from 'react-quill'; // Typescript
import quillEmoji from 'quill-emoji';
import { Glyphicon } from 'react-bootstrap';

function insertName() {
    const cursorPosition = this.quill.getSelection().index;
    this.quill.insertText(cursorPosition, "{name}");
    this.quill.setSelection(cursorPosition + 1);
}

const CustomButtonUser = () => <Glyphicon glyph="user"/>;
const CustomToolbar = ({id}) => (
    <div id={"toolbar" + id}>
      <select className="ql-size" defaultValue={""} onChange={e => e.persist()}>
        <option value="large" />
        <option selected />
      </select>
      <button className="ql-bold" />
      <button className="ql-italic" />
      <select className="ql-color">
        <option value="#12C4C4" />
        <option value="#6F69B4" />
        <option value="#5AA5EF" />
        <option value="#93CF47" />
        <option value="#E66882" />
        <option selected />
      </select>
      <button className="ql-insertName">
        <CustomButtonUser />
      </button>
      <button className="ql-emoji" />
      <button className="ql-link" />
      <button className="ql-clean" />
    </div>
  );

const { EmojiBlot, ShortNameEmoji, ToolbarEmoji, TextAreaEmoji } = quillEmoji;

Quill.register({
  'formats/emoji': EmojiBlot,
  'modules/emoji-shortname': ShortNameEmoji,
  'modules/emoji-toolbar': ToolbarEmoji,
  'modules/emoji-textarea': TextAreaEmoji
}, true);

export default class QuillComponent extends React.Component<any, any> {

    private modules = {
        toolbar: {
            container: "#toolbar"+this.props.id,
            handlers: {
                insertName: insertName
            }
        },
        'emoji-toolbar': true,
        "emoji-textarea": true,
        "emoji-shortname": true,
        clipboard: {
          matchVisual: false,
        }
      };
     
    private formats = ['font', 'header', 'size', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block', 'color', 'background', 'list', 'indent', 'align', 'link', 'image', 'clean', 'emoji']

    constructor(props:any) {
        super(props);

        this.state = {
        }
    }

    render() {
        return (
            <div className="text-editor">
                <CustomToolbar id={this.props.id} />
                <ReactQuill id={this.props.id} value={this.props.pageInput} onChange={this.props.updatePageInput} modules={this.modules} formats={this.formats}/>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/storyEditComponent/QuillComponent.tsx